module.exports = __webpack_public_path__ + "img/kleisma1m.51fc037c.webp";